import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './Navbar.css'; // Importe os estilos do Navbar
import './Footer.css'; // Importe os estilos do Footer

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <App />
);